export default {"src":"/_next/static/media/visa.ae4416f8.svg","height":24,"width":32};